import React, { Suspense } from "react";

const Revenue = React.lazy(() => import("@/pages/revenue"));

export default function RevenueContainer() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div></div>}>
      <Revenue />
    </Suspense>
  );
}
